




<mat-toolbar class="mat-elevation-z6 d-flex justify-content-between header-toolbar no-print" *ngIf="isNotPrintRoute">
  
          <div>

            <!-- <button class="my-2 position-header" *ngIf="router.url == '/suche'" (click)="toggleDrawer()" type="button" mat-button>
              <mat-icon>
                menu
              </mat-icon>
            </button> -->
              <button [routerLink]="['/suche']" [routerLinkActive]="'is-active'" mat-menu-item>Zurück zur Suche</button>
          </div>
          <div>
            <div class="border-left">
              <button  mat-menu-item (click)="openDialog()" matBadge="{{count}}" matBadgePosition="below before" >Merkliste  </button>
              
            </div>
          </div>

</mat-toolbar>

